import { ResourcesPanel } from "@/components/ResourcesPanel";
export default function ClientResources() {
  return <div className="lg:mt-0 mt-10"><ResourcesPanel testid="client-resources" /></div>;
}
